export const defaultHotfixItem = {
    sha: ''
};